import { render, staticRenderFns } from "./chartWeekly.vue?vue&type=template&id=4a7ddca5"
import script from "./chartWeekly.vue?vue&type=script&lang=js"
export * from "./chartWeekly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports